import { SliderFilledTrack } from "@chakra-ui/react"

const SliderPics = [
    {
        image:"https://akamaividz2.zee5.com/image/upload/w_1420,h_569,c_scale,f_webp,q_auto:eco/resources/0-0-1z5218775/cover/1920x770caf89748d24946bd8f410be2aa2f351d.jpg"
    },
    {
        image:"https://akamaividz2.zee5.com/image/upload/w_1420,h_569,c_scale,f_webp,q_auto:eco/resources/0-6-3392/cover/1920x770f3f17699f7f5449d97081bd147f44b67.jpg"
    },
    {
        image:"https://akamaividz2.zee5.com/image/upload/w_1420,h_569,c_scale,f_webp,q_auto:eco/resources/0-6-4z5173774/cover/1920x77077519c4212e549d39a36690eec17509e.jpg"
    },
    {
        image:"https://akamaividz2.zee5.com/image/upload/w_1420,h_569,c_scale,f_webp,q_auto:eco/resources/0-6-366/cover/1920x770126fa06f926048bf8125944ea2814207.jpg"
    },
    {
        image:"https://akamaividz2.zee5.com/image/upload/w_1420,h_569,c_scale,f_webp,q_auto:eco/resources/0-0-1z5206274/cover/1920x770624681d282d348569ae038134fb002f847561990dc274badb1e1b41c74423b34.jpg"
    },
    {
        image:"https://akamaividz2.zee5.com/image/upload/w_1420,h_569,c_scale,f_webp,q_auto:eco/resources/0-6-4z5193948/cover/1920x770b90f094643b54d1193e437a5ba25b97c.jpg"
    },
]

export default SliderPics;